import PermissionAPI from 'api/permission';
import PermissionGroupAPI from 'api/permissiongroup';
import RoleAPI from 'api/role';
import {
  action, makeAutoObservable, observable
} from 'mobx';

export default class RoleStore {
  roleApi: RoleAPI;

  permissionApi: PermissionAPI;

  permissionGroupApi: PermissionGroupAPI;

  constructor({ refreshToken }) {
    makeAutoObservable(this);
    this.roleApi = new RoleAPI({ refreshToken });
    this.permissionApi = new PermissionAPI({ refreshToken });
    this.permissionGroupApi = new PermissionGroupAPI({ refreshToken });
  }

  @observable loading = true;
  @observable permissionsData = [];

  @action
  getData(applicationId, channelId, roleId) {
    return new Promise((resolve, reject) => {
      this.loading = true;
      const promise = [
        this.permissionApi.getPermission(applicationId),
        this.permissionGroupApi.getPermissionGroup(applicationId),
        roleId && this.roleApi.getRole(roleId)
      ].filter(Boolean);

      Promise.all(promise)
        .then(results => {
          const permissions = results[0]?.data?.data ?? [];
          const permissionsGroup = (results[1]?.data?.data ?? []);
          const roleInfo = results[2]?.data ?? {};
          this.permissionsData = permissionsGroup.map((e) => ({ ...e, child: permissions.filter((p) => (p.groupId == e.id)) }));
        
          let rolePermissions = [];

          if (roleInfo?.permissions?.includes('*')) {
            rolePermissions = permissions.map(i => i.code);
          } else {
            rolePermissions = roleInfo?.permissions?.filter(v => v != '*' && !!v) ?? [];
          }

          resolve({ roleInfo, rolePermissions });
        })
        .finally(() => {
          this.loading = false;
        });
    });
  };
}
